import { render, staticRenderFns } from "./VDate.vue?vue&type=template&id=71020ca4&scoped=true"
import script from "./VDate.vue?vue&type=script&lang=js"
export * from "./VDate.vue?vue&type=script&lang=js"
import style0 from "./VDate.vue?vue&type=style&index=0&id=71020ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71020ca4",
  null
  
)

export default component.exports